var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"
}))));
export { SvgAdd as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjNhV1IwYUQwaU1qUWlJR2hsYVdkb2REMGlNalFpSUhacFpYZENiM2c5SWpBZ01DQXlOQ0F5TkNJZ1ptbHNiRDBpWTNWeWNtVnVkRU52Ykc5eUlpQjRiV3h1Y3owaWFIUjBjRG92TDNkM2R5NTNNeTV2Y21jdk1qQXdNQzl6ZG1jaVBnbzhiV0Z6YXlCcFpEMGliV0Z6YXpCZk5qQXpYemt4T1RVeklpQnpkSGxzWlQwaWJXRnpheTEwZVhCbE9tRnNjR2hoSWlCdFlYTnJWVzVwZEhNOUluVnpaWEpUY0dGalpVOXVWWE5sSWlCNFBTSXdJaUI1UFNJd0lpQjNhV1IwYUQwaU1qUWlJR2hsYVdkb2REMGlNalFpUGdvOGNtVmpkQ0IzYVdSMGFEMGlNalFpSUdobGFXZG9kRDBpTWpRaUx6NEtQQzl0WVhOclBnbzhaeUJ0WVhOclBTSjFjbXdvSTIxaGMyc3dYell3TTE4NU1UazFNeWtpUGdvOGNHRjBhQ0JrUFNKTk1URWdNVE5JTlZZeE1VZ3hNVlkxU0RFelZqRXhTREU1VmpFelNERXpWakU1U0RFeFZqRXpXaUl2UGdvOEwyYytDand2YzNablBnbz0i";